<div class="cw-adyen">
  @if (isLoading()) {
    <div class="cw-adyen__loading">
      {{ 'adyen.loading' | translate }}
    </div>
  }

  @if (errorMessage(); as error) {
    <div class="alert alert-danger summary-warning" role="alert">
      {{ error | translate }}
      <!-- A Pending payment gets the same way out: the customer, not the widget, decides to pay again. -->
      @if (canRetry() || isHeld()) {
        <button type="button" class="btn btn-link alert-link p-0 cw-adyen__retry" (click)="retry()">
          {{ 'adyen.retry' | translate }}
        </button>
      }
    </div>
  }

  <!--
    Adyen's hosted page, in place of Drop-in: this origin is not allowed on the client key, so the
    shopper pays in a popup on Adyen's own page. The click must open it directly - see
    payWithHostedCheckout().
  -->
  @if (hostedSession(); as session) {
    @if (!errorMessage()) {
    <div class="cw-adyen__hosted cbw-adyen-hosted">
      @if (resumeUnavailable()) {
        <div class="alert alert-warning cw-adyen__resume-unavailable" role="status">
          {{ 'adyen.errors.resume_unavailable' | translate }}
        </div>
      }
      @if (popupBlocked()) {
        <div class="alert alert-warning cw-adyen__popup-blocked" role="alert">
          {{ 'adyen.hosted.popup_blocked' | translate }}
        </div>
      }
      <calenso-button
        type="primary"
        placement="left"
        customCss="cw-adyen__hosted-pay cbw-adyen-hosted-pay-button"
        [text]="'adyen.hosted.pay_button' | translate"
        [disabled]="hostedAwaiting()"
        (clickEvent)="payWithHostedCheckout()"
      />
      <p class="cw-adyen__hosted-hint">
        {{ (hostedAwaiting() ? 'adyen.hosted.waiting' : 'adyen.hosted.hint') | translate }}
      </p>
      <!--
        The way back to Adyen's page when its window was lost (closed by accident, opened as a tab on
        a phone, or blocked). A link, because a click on it opens reliably; the result still comes
        back to this window, which keeps reading it.
      -->
      @if (hostedAwaiting() || popupBlocked()) {
        <p class="cw-adyen__hosted-return">
          {{ 'adyen.hosted.return_hint' | translate }}
          <a
            class="cw-adyen__hosted-link cbw-adyen-hosted-link"
            [href]="session.url"
            [attr.target]="popupName"
            (click)="onCompletePaymentLink($event)"
          >{{ 'adyen.hosted.complete_payment' | translate }}</a>
        </p>
      }
    </div>
    }
  }

  <!--
    Drop-in renders through this slot, not in place. AdyenLoaderService appends
    adyen.css to document.head, and a stylesheet there cannot cross a shadow
    boundary — inside the custom element the Drop-in would render completely
    unstyled. The container is therefore moved into a light-DOM host carrying
    `slot="<slotName>"`, exactly as the Stripe component does, and rendered back
    here. Only the container crosses; the loading and error states above stay
    inside the shadow root.
  -->
  <slot [attr.name]="slotName"></slot>
</div>

<!--
  Never rendered in place: projectDropinIntoLightDom() creates this view manually
  and moves its root nodes into the slotted host. The mount reads the element
  straight off the created view rather than through a @ViewChild, because a view
  created in ngAfterViewInit is not visible to a view query until the next
  change-detection pass — and Drop-in must never mount against undefined.
-->
<ng-template #dropinTpl>
  <div class="cw-adyen__dropin"></div>
</ng-template>
